import { useState, useRef } from "react";
import { supabase, dbApplyWo, dbLoadStateLite, dbSavePlayers, dbInsertChallenge, dbUpdateChallenge, dbDeleteChallenge, dbInsertResult, dbInsertNotifications, dbDeletePlayerNotifs, dbInsertBlockedDate, dbDeleteBlockedDate, dbInsertPositionHistory, dbAddHoliday, dbDeleteHoliday, dbInsertInactivityHistory, dbLoadInactivityHistory, dbLoadAllInactivityHistory, dbUpdateInactivityHistory, dbDeleteInactivityHistory, dbUpsertCourtSlot, dbDeleteCourtSlot, dbInsertBlockedPeriod, dbDeleteBlockedPeriod } from "../lib/supabase";
import { CONFIRM_DEADLINE_DAYS, RULES_SECTIONS, GENDER } from "../constants";
import { tc, fmtDate, getInactivityPenalty } from "../lib/helpers";
import { nowBR, todayStrBR, inactiveDaysUntilBR, oneMonthFromNowISO } from "../lib/timezone";
import { buildPositionHistoryEntries } from "./useChallenges";

// Resolve o nome da tabela correta pelo gênero
function tbl(gender, key) {
  return GENDER.tables[gender]?.[key] ?? GENDER.tables.M[key];
}

export function useAdmin({ state, save, flash, gender }) {
  // ── Estado admin ────────────────────────────────────────────────────────────
  const [adminTab, setAdminTab]                   = useState("challenges");

  // jogadores
  const [newPlayerName, setNewPlayerName]         = useState("");
  const [removePlayerId, setRemovePlayerId]       = useState("");
  const [removeConfirm, setRemoveConfirm]         = useState(false);
  const [resetPlayerId, setResetPlayerId]         = useState("");
  const [resetNewPass, setResetNewPass]           = useState("");
  const [adjustPlayerId, setAdjustPlayerId]       = useState("");
  const [adjustPosition, setAdjustPosition]       = useState("");
  const removingPlayerRef                         = useRef(false); // trava contra remoção concorrente/duplo-clique

  // edição de jogador (admin)
  const [editPlayerModal, setEditPlayerModal]     = useState(null);
  const [editPlayerName, setEditPlayerName]       = useState("");
  const [editPlayerEmail, setEditPlayerEmail]     = useState("");
  const [editPlayerPhone, setEditPlayerPhone]     = useState("");

  // desafios admin
  const [adminChrID, setAdminChrID]               = useState("");
  const [adminChdID, setAdminChdID]               = useState("");
  const [adminChalDate, setAdminChalDate]         = useState("");
  const [cancelChalId, setCancelChalId]           = useState("");
  const [cancelChalConfirm, setCancelChalConfirm] = useState(false);
  const [editChalId, setEditChalId]               = useState("");
  const [editChalDate, setEditChalDate]           = useState("");

  // propor como jogador
  const [propAsChrID, setPropAsChrID]             = useState("");
  const [propAsChdID, setPropAsChdID]             = useState("");
  const [propAsDates, setPropAsDates]             = useState(["", "", ""]);

  // resultados
  const [resultChalId, setResultChalId]           = useState("");
  const [resultWinner, setResultWinner]           = useState("");
  const [resultType, setResultType]               = useState("normal");
  const [resultSets, setResultSets]               = useState([{ a: "", b: "" }, { a: "", b: "" }, { a: "", b: "" }]);
  const [resultConfirmModal, setResultConfirmModal] = useState(false);
  const [editResultId, setEditResultId]           = useState(null);
  const [editResultWinner, setEditResultWinner]   = useState("");
  const [editResultType, setEditResultType]       = useState("normal");
  const [editResultSets, setEditResultSets]       = useState([{ a: "", b: "" }, { a: "", b: "" }, { a: "", b: "" }]);

  // inatividade / bloqueio
  const [inactivePlayer, setInactivePlayer]       = useState("");
  const [inactiveSearch, setInactiveSearch]       = useState("");
  const [inactiveSearchOpen, setInactiveSearchOpen] = useState(false);
  const [inactiveDays, setInactiveDays]           = useState(15);

  // regras
  const [editingRule, setEditingRule]             = useState(null);
  const [editRuleIcon, setEditRuleIcon]           = useState("");
  const [editRuleTitle, setEditRuleTitle]         = useState("");
  const [editRuleText, setEditRuleText]           = useState("");

  // datas bloqueadas
  const [blockDate, setBlockDate]                 = useState("");
  const [blockAllDay, setBlockAllDay]             = useState(true);
  const [blockHours, setBlockHours]               = useState([]);

  // feriados
  const [holidayDate, setHolidayDate]             = useState("");
  const [holidayName, setHolidayName]             = useState("");

  // court slots
  const [slotDayType, setSlotDayType]             = useState("saturday");
  const [slotHour, setSlotHour]                   = useState("");
  const [slotMaxCourts, setSlotMaxCourts]         = useState(1);

  // blocked periods
  const [periodDateFrom, setPeriodDateFrom]       = useState("");
  const [periodDateTo, setPeriodDateTo]           = useState("");
  const [periodAllDay, setPeriodAllDay]           = useState(true);
  const [periodHours, setPeriodHours]             = useState([]);
  const [periodLabel, setPeriodLabel]             = useState("");

  // histórico de inatividade
  const [inactivityHistory, setInactivityHistory]         = useState([]);
  const [histPlayerSearch, setHistPlayerSearch]           = useState("");
  const [histPlayerSearchOpen, setHistPlayerSearchOpen]   = useState(false);
  const [histPlayerId, setHistPlayerId]                   = useState("");
  const [histSince, setHistSince]                         = useState("");
  const [histUntil, setHistUntil]                         = useState("");
  const [histPenalty, setHistPenalty]                     = useState(0);
  const [histLoading, setHistLoading]                     = useState(false);
  const [editingHistId, setEditingHistId]                 = useState(null);
  const [editHistSince, setEditHistSince]                 = useState("");
  const [editHistUntil, setEditHistUntil]                 = useState("");
  const [editHistPenalty, setEditHistPenalty]             = useState(0);

  // ── Jogadores ───────────────────────────────────────────────────────────────
  async function addPlayer() {
    if (!newPlayerName.trim()) return;
    const s = JSON.parse(JSON.stringify(state));
    const newPos = s.players.length + 1;
    const newPlayer = { name: tc(newPlayerName.trim()), position: newPos, password: "senha123", blockedAsChallenger: null, blockedAsChallenged: null, inactiveUntil: null, inactiveSince: null, photo: null };
    let newId;
    try {
      const { data, error } = await supabase
        .from(tbl(gender, "players"))
        .insert({ name: newPlayer.name, position: newPlayer.position, password: newPlayer.password })
        .select().single();
      if (error) throw error;
      newId = data.id;
    } catch (e) { console.error(e); flash("Erro ao adicionar jogador.", "error"); return; }
    newPlayer.id = newId;
    s.players.push(newPlayer);
    save(s); setNewPlayerName(""); flash("Jogador adicionado na posição " + newPos);
  }

  async function removePlayer() {
    if (!removePlayerId) { flash("Selecione um jogador.", "error"); return; }
    if (removingPlayerRef.current) return; // evita duplo-clique / execução concorrente
    removingPlayerRef.current = true;
    try {
      const s = JSON.parse(JSON.stringify(state));
      const p = s.players.find(x => x.id === parseInt(removePlayerId));
      if (!p) { flash("Jogador não encontrado.", "error"); return; }

      // Busca as posições REAIS direto do banco (fonte da verdade) em vez de
      // confiar no `state` em memória, que pode estar desatualizado se outra
      // operação de posição rodou entre o load e este clique (race condition).
      const { data: freshPlayers, error: fetchError } = await supabase
        .from(tbl(gender, "players"))
        .select("id, position");
      if (fetchError) throw fetchError;

      const freshPosMap = {};
      freshPlayers.forEach(x => { freshPosMap[x.id] = x.position; });
      const pos = freshPosMap[p.id] ?? p.position;

      const remaining = s.players.filter(x => x.id !== p.id);
      remaining.forEach(x => {
        const realPos = freshPosMap[x.id] ?? x.position;
        x.position = realPos > pos ? realPos - 1 : realPos;
      });

      // Desafios pendentes/ativos dessa jogadora (os já resolvidos não estão mais
      // em `challenges` — foram movidos para `results` quando o resultado foi lançado).
      const relatedChallenges = state.challenges.filter(
        c => c.challengerId === p.id || c.challengedId === p.id
      );

      // 1) Apaga no banco os desafios e notificações da jogadora ANTES de tentar
      //    excluí-la — a FK de challenges_f é NO ACTION e bloqueia a exclusão
      //    enquanto existir qualquer desafio referenciando o id dela.
      //    (results/results_f não têm FK para players — resultados já lançados
      //    nunca são afetados por esta operação.)
      for (const c of relatedChallenges) {
        await dbDeleteChallenge(c.id, gender);
      }
      await dbDeletePlayerNotifs(p.id, gender);

      // 2) Salva as posições recalculadas das jogadoras restantes
      await dbSavePlayers(remaining, gender);

      // 3) Só então apaga a jogadora — conferindo o erro de verdade
      const { error: delError } = await supabase
        .from(tbl(gender, "players"))
        .delete()
        .eq("id", p.id);
      if (delError) throw delError;

      s.players = remaining;
      s.challenges = s.challenges.filter(c => c.challengerId !== p.id && c.challengedId !== p.id);
      s.notifications = s.notifications.filter(n => n.playerId !== p.id);

      save(s); setRemovePlayerId(""); setRemoveConfirm(false); flash(`${p.name} removido do ranking.`);
    } catch (e) {
      console.error(e); flash("Erro ao remover jogador.", "error");
    } finally {
      removingPlayerRef.current = false;
    }
  }

  async function resetPassword() {
    if (!resetPlayerId || !resetNewPass.trim()) { flash("Selecione o jogador e a nova senha.", "error"); return; }
    const s = JSON.parse(JSON.stringify(state));
    const p = s.players.find(x => x.id === parseInt(resetPlayerId));
    if (!p) return;
    p.password = resetNewPass.trim(); save(s);
    try { await dbSavePlayers([p], gender); } catch (e) { flash("Erro ao redefinir senha.", "error"); return; }
    setResetPlayerId(""); setResetNewPass(""); flash("Senha de " + p.name + " redefinida!");
  }

  async function adjustPlayerPosition() {
    if (!adjustPlayerId || !adjustPosition) { flash("Preencha os campos.", "error"); return; }
    const newPos = parseInt(adjustPosition);
    const s = JSON.parse(JSON.stringify(state));
    const p = s.players.find(x => x.id === parseInt(adjustPlayerId));
    if (!p) return;
    const oldPos = p.position;
    if (newPos === oldPos) { flash("Posição igual à atual.", "error"); return; }
    if (newPos < 1 || newPos > s.players.length) { flash("Posição inválida.", "error"); return; }
    const prevPositions = {};
    s.players.forEach(x => { prevPositions[x.id] = x.position; });
    if (newPos < oldPos) s.players.forEach(x => { if (x.id !== p.id && x.position >= newPos && x.position <= oldPos - 1) x.position++; });
    else                 s.players.forEach(x => { if (x.id !== p.id && x.position >= oldPos + 1 && x.position <= newPos) x.position--; });
    p.position = newPos;
    const now = nowBR();
    const reasonMap = { [p.id]: { reason: "admin", detail: `Ajuste manual pelo admin: #${oldPos} → #${newPos}` } };
    const histEntries = buildPositionHistoryEntries(s.players, prevPositions, now, reasonMap);
    save(s);
    try {
      await dbSavePlayers(s.players, gender);
      await dbInsertPositionHistory(histEntries, gender);
    } catch (e) { flash("Erro ao ajustar posição.", "error"); return; }
    setAdjustPlayerId(""); setAdjustPosition(""); flash(p.name + " movido para #" + newPos);
  }

  async function saveEditPlayer() {
    if (!editPlayerModal) return;
    const s = JSON.parse(JSON.stringify(state));
    const p = s.players.find(x => x.id === editPlayerModal.id);
    if (!p) return;
    p.name = editPlayerName || p.name; p.email = editPlayerEmail; p.phone = editPlayerPhone;
    try {
      const { error } = await supabase
        .from(tbl(gender, "players"))
        .update({ name: p.name, email: p.email || null, phone: p.phone || null })
        .eq("id", p.id);
      if (error) throw error;
    } catch (e) { flash("Erro ao salvar jogador.", "error"); return; }
    save(s); setEditPlayerModal(null); flash("Jogador atualizado!");
  }

  // ── Desafios admin ──────────────────────────────────────────────────────────
  async function cancelChallenge() {
    if (!cancelChalId) { flash("Selecione o desafio.", "error"); return; }
    const s = JSON.parse(JSON.stringify(state));
    const ch = s.challenges.find(c => c.id === parseInt(cancelChalId));
    if (!ch) return;
    const chr = s.players.find(p => p.id === ch.challengerId);
    const chd = s.players.find(p => p.id === ch.challengedId);
    const now = nowBR();
    const newNotifs = [
      { playerId: ch.challengerId, text: `Desafio contra ${chd?.name || "-"} foi cancelado pelo admin.`, date: now, read: false },
      { playerId: ch.challengedId, text: `Desafio de ${chr?.name || "-"} foi cancelado pelo admin.`, date: now, read: false },
    ];
    try {
      await dbInsertNotifications(newNotifs, gender);
      await dbDeleteChallenge(ch.id, gender);
    } catch (e) { console.error(e); flash("Erro ao cancelar desafio.", "error"); return; }
    newNotifs.forEach(n => s.notifications.unshift({ ...n, id: Date.now() + Math.random() }));
    s.challenges = s.challenges.filter(c => c.id !== parseInt(cancelChalId));
    save(s); setCancelChalId(""); flash("Desafio cancelado.");
  }

  async function adminProposeChallenge() {
    if (!adminChrID || !adminChdID || !adminChalDate) { flash("Preencha todos os campos.", "error"); return; }
    if (!adminChalDate.includes("T") || adminChalDate.endsWith("T")) { flash("Selecione também o horário do desafio.", "error"); return; }
    if (adminChrID === adminChdID) { flash("Desafiante e desafiado não podem ser o mesmo.", "error"); return; }
    const s = JSON.parse(JSON.stringify(state));
    const chr = s.players.find(p => p.id === parseInt(adminChrID));
    const chd = s.players.find(p => p.id === parseInt(adminChdID));
    if (!chr || !chd) return;
    const newChallenge = {
      challengerId: chr.id, challengedId: chd.id,
      challengerName: chr.name, challengedName: chd.name,
      dates: [adminChalDate, "", ""], confirmedDate: adminChalDate, lastProposedBy: "challenger",
      proposedAt: nowBR(), status: "agendado", adminCreated: true,
    };
    try {
      const newId = await dbInsertChallenge(newChallenge, gender);
      newChallenge.id = newId;
      s.challenges.push(newChallenge);
      const now = nowBR();
      const notifText = `Desafio agendado: ${chr.name} x ${chd.name} em ${fmtDate(adminChalDate)}`;
      const newNotifs = [
        { playerId: chd.id, text: notifText, date: now, read: false },
        { playerId: chr.id, text: notifText, date: now, read: false },
      ];
      await dbInsertNotifications(newNotifs, gender);
      newNotifs.forEach(n => s.notifications.unshift({ ...n, id: Date.now() + Math.random() }));
      save(s); setAdminChrID(""); setAdminChdID(""); setAdminChalDate(""); flash("Desafio agendado!");
    } catch (e) { console.error(e); flash("Erro ao agendar desafio.", "error"); }
  }

  async function adminProposeAsPlayer() {
    if (!propAsChrID || !propAsChdID) { flash("Selecione desafiante e desafiado.", "error"); return; }
    if (propAsChrID === propAsChdID) { flash("Desafiante e desafiado não podem ser o mesmo.", "error"); return; }
    const filledDates = propAsDates.filter(d => d.trim());
    if (filledDates.length < 3) { flash("Preencha as 3 opções de data.", "error"); return; }
    const hasWeekend = filledDates.some(d => { const dow = new Date(d.split("T")[0] + "T12:00:00").getDay(); return dow === 0 || dow === 6; });
    if (!hasWeekend) { flash("Pelo menos uma data deve ser no fim de semana.", "error"); return; }
    const s = JSON.parse(JSON.stringify(state));
    const chr = s.players.find(p => p.id === parseInt(propAsChrID));
    const chd = s.players.find(p => p.id === parseInt(propAsChdID));
    if (!chr || !chd) return;
    const activeChr = s.challenges.filter(c => c.challengerId === chr.id).length;
    if (activeChr >= 1) { flash(`${chr.name} já possui um desafio ativo como desafiante.`, "error"); return; }
    const activeChd = s.challenges.filter(c => c.challengedId === chd.id).length;
    if (activeChd >= 1) { flash(`${chd.name} já possui um desafio ativo como desafiado.`, "error"); return; }
    const newChallenge = {
      challengerId: chr.id, challengedId: chd.id,
      challengerName: chr.name, challengedName: chd.name,
      dates: [...propAsDates], confirmedDate: null,
      proposedAt: nowBR(), status: "aguardando_confirmacao",
      adminCreated: true, lastProposedBy: "challenger",
    };
    try {
      const newId = await dbInsertChallenge(newChallenge, gender);
      newChallenge.id = newId;
      s.challenges.push(newChallenge);
      const notif = { playerId: chd.id, text: `${chr.name} te desafiou! Você tem ${CONFIRM_DEADLINE_DAYS} dias para confirmar uma data.`, date: nowBR(), read: false };
      await dbInsertNotifications([notif], gender);
      s.notifications.unshift({ ...notif, id: Date.now() });
      save(s); setPropAsChrID(""); setPropAsChdID(""); setPropAsDates(["", "", ""]);
      flash(`Desafio proposto: ${chr.name} → ${chd.name}`);
    } catch (e) { console.error(e); flash("Erro ao propor desafio.", "error"); }
  }

  async function editChallengeDate() {
    if (!editChalId || !editChalDate) { flash("Selecione o desafio e a nova data.", "error"); return; }
    const s = JSON.parse(JSON.stringify(state));
    const ch = s.challenges.find(c => c.id === parseInt(editChalId));
    if (!ch) return;
    ch.confirmedDate = editChalDate; ch.status = "agendado";
    const now = nowBR();
    const notifs = [
      { playerId: ch.challengerId, text: `Data do desafio alterada pelo admin para ${fmtDate(editChalDate)}.`, date: now, read: false },
      { playerId: ch.challengedId, text: `Data do desafio alterada pelo admin para ${fmtDate(editChalDate)}.`, date: now, read: false },
    ];
    try {
      await dbUpdateChallenge(ch.id, { status: "agendado", confirmedDate: editChalDate }, gender);
      await dbInsertNotifications(notifs, gender);
    } catch (e) { console.error(e); flash("Erro ao atualizar data.", "error"); return; }
    notifs.forEach(n => s.notifications.unshift({ ...n, id: Date.now() + Math.random() }));
    save(s); setEditChalId(""); setEditChalDate(""); flash("Data do desafio atualizada!");
  }

  // ── Resultados ──────────────────────────────────────────────────────────────
  function requestResultConfirm() {
    if (!resultChalId || (resultType === "normal" && !resultWinner)) { flash("Preencha todos os campos.", "error"); return; }
    setResultConfirmModal(true);
  }

  async function registerResult() {
    setResultConfirmModal(false);
    if (!resultChalId || (resultType === "normal" && !resultWinner)) { flash("Preencha todos os campos.", "error"); return; }
    const s = JSON.parse(JSON.stringify(state));
    const ch = s.challenges.find(c => c.id === parseInt(resultChalId));
    if (!ch) return;
    const chr = s.players.find(p => p.id === ch.challengerId);
    const chd = s.players.find(p => p.id === ch.challengedId);
    if (!chr || !chd) return;
    // W.O. (desafiado ou desafiante): penalidade aplicada no banco, em uma única
    // transação (apply_wo_penalty). Resultados normais seguem o fluxo abaixo.
    if (resultType === "wo-challenged" || resultType === "wo-challenger") {
      try {
        const r = await dbApplyWo({ gender, challengeId: ch.id, type: resultType, origin: "admin" });
        const fresh = await dbLoadStateLite(gender, state);
        save(fresh);
        setResultChalId(""); setResultWinner(""); setResultType("normal"); setResultSets([{ a: "", b: "" }, { a: "", b: "" }, { a: "", b: "" }]);
        if (r && r.applied) flash("Resultado registrado!");
        else flash("Este desafio já foi processado.", "info");
      } catch (e) { console.error(e); flash("Erro ao registrar resultado.", "error"); }
      return;
    }
    const prevPositions = {};
    s.players.forEach(p => { prevPositions[p.id] = p.position; });
    const oneMonth = oneMonthFromNowISO();
    const now = nowBR();
    const newNotifs = [];
    if (resultType === "wo-challenged") {
      const lp = chd.position;
      // Penalidade: cai até a posição do desafiante OU 5 posições, o que for pior (maior número)
      const woPenaltyPos = Math.min(Math.max(chr.position, lp + 5), s.players.length);
      const posDrop = woPenaltyPos - lp;
      s.players.forEach(p => { if (p.position > lp && p.position <= woPenaltyPos) p.position--; });
      chd.position = woPenaltyPos;
      newNotifs.push({ playerId: chd.id, text: `Você perdeu por W.O. e caiu ${posDrop} posição${posDrop > 1 ? "ões" : ""} (#${lp} → #${woPenaltyPos}).`, date: now, read: false });
      newNotifs.push({ playerId: chr.id, text: "Adversário deu W.O. Você pode propor novo desafio.", date: now, read: false });
    } else if (resultType === "wo-challenger") {
      const lp = chr.position; s.players.forEach(p => { if (p.position > lp && p.position <= lp + 5) p.position--; }); chr.position = Math.min(lp + 5, s.players.length);
      chr.blockedAsChallenger = oneMonth;
      newNotifs.push({ playerId: chr.id, text: "Você deu W.O. e caiu 5 posições. Indisponível para desafiar por 1 mês.", date: now, read: false });
      newNotifs.push({ playerId: chd.id, text: `${chr.name} deu W.O.`, date: now, read: false });
    } else if (resultWinner === "challenger") {
      const np = chd.position, op = chr.position; s.players.forEach(p => { if (p.id !== chr.id && p.position >= np && p.position <= op - 1) p.position++; }); chr.position = np;
      chd.blockedAsChallenged = oneMonth;
      newNotifs.push({ playerId: chr.id, text: `Vitória! Você subiu para #${np}.`, date: now, read: false });
      newNotifs.push({ playerId: chd.id, text: `Derrota para ${chr.name}. Indisponível para receber desafios por 1 mês.`, date: now, read: false });
    } else {
      chd.blockedAsChallenged = oneMonth; chr.blockedAsChallenger = oneMonth;
      newNotifs.push({ playerId: chd.id, text: `Vitória sobre ${chr.name}! Indisponível para receber desafios por 1 mês.`, date: now, read: false });
      newNotifs.push({ playerId: chr.id, text: `Derrota para ${chd.name}. Indisponível para desafiar por 1 mês.`, date: now, read: false });
    }
    const scoreStr = resultSets.filter(set => set.a !== "" || set.b !== "").map(set => set.a + "/" + set.b).join(", ");
    const newResult = { challengeId: ch.id, challengerName: chr.name, challengedName: chd.name, winner: resultType === "normal" ? resultWinner : null, type: resultType, score: scoreStr, date: now };
    s.results.push(newResult);
    const reasonMap = {};
    if (resultType === "wo-challenged") {
      reasonMap[chd.id] = { reason: "wo", detail: `W.O. (ausência) — caiu de #${prevPositions[chd.id]} para #${chd.position}` };
    } else if (resultType === "wo-challenger") {
      reasonMap[chr.id] = { reason: "wo", detail: `W.O. (ausência) — caiu 5 posições (era #${prevPositions[chr.id]})` };
    } else if (resultWinner === "challenger") {
      reasonMap[chr.id] = { reason: "game_win", detail: `Vitória sobre ${chd.name} — subiu de #${prevPositions[chr.id]}` };
      reasonMap[chd.id] = { reason: "game_loss", detail: `Derrota para ${chr.name} — caiu de #${prevPositions[chd.id]}` };
    } else {
      reasonMap[chd.id] = { reason: "game_win", detail: `Vitória sobre ${chr.name} — manteve #${prevPositions[chd.id]}` };
      reasonMap[chr.id] = { reason: "game_loss", detail: `Derrota para ${chd.name} — manteve #${prevPositions[chr.id]}` };
    }
    s.players.forEach(p => { const prev = prevPositions[p.id]; if (prev !== undefined && prev !== p.position) { p.positionDelta = prev - p.position; p.positionDeltaDate = now; } });
    const histEntries = buildPositionHistoryEntries(s.players, prevPositions, now, reasonMap);
    s.challenges = s.challenges.filter(c => c.id !== ch.id);
    save(s);
    try {
      await dbSavePlayers(s.players, gender);
      await dbInsertResult(newResult, gender);
      await dbDeleteChallenge(ch.id, gender);
      await dbInsertNotifications(newNotifs, gender);
      await dbInsertPositionHistory(histEntries, gender);
      newNotifs.forEach(n => s.notifications.unshift({ ...n, id: Date.now() + Math.random() }));
      save({ ...s });
      setResultChalId(""); setResultWinner(""); setResultType("normal"); setResultSets([{ a: "", b: "" }, { a: "", b: "" }, { a: "", b: "" }]);
      flash("Resultado registrado!");
    } catch (e) { console.error(e); flash("Erro ao registrar resultado.", "error"); }
  }

  async function saveEditResult() {
    if (!editResultId) return;
    const s = JSON.parse(JSON.stringify(state));
    const r = s.results.find(x => x.id === editResultId);
    if (!r) return;
    const scoreStr = editResultSets.filter(set => set.a !== "" || set.b !== "").map(set => set.a + "/" + set.b).join(", ");
    r.winner = editResultWinner || r.winner; r.type = editResultType;
    r.score = editResultType === "normal" ? scoreStr : "";
    try {
      const { error } = await supabase
        .from(tbl(gender, "results"))
        .update({ winner: r.winner, type: r.type, score: r.score })
        .eq("id", r.id);
      if (error) throw error;
    } catch (e) { console.error(e); flash("Erro ao atualizar resultado.", "error"); return; }
    save(s); setEditResultId(null); flash("Resultado atualizado!");
  }

  async function deleteResult(id) {
    const targetId = id ?? editResultId;
    if (!targetId) return;
    const s = JSON.parse(JSON.stringify(state));
    try {
      const { error } = await supabase
        .from(tbl(gender, "results"))
        .delete()
        .eq("id", targetId);
      if (error) throw error;
    } catch (e) { console.error(e); flash("Erro ao apagar resultado.", "error"); return; }
    s.results = s.results.filter(x => x.id !== targetId);
    save(s); setEditResultId(null); flash("Resultado apagado.");
  }

  // ── Inatividade / bloqueio ──────────────────────────────────────────────────
  async function setInactivity() {
    if (!inactivePlayer) return;
    const days = parseInt(inactiveDays);
    if (!days || days < 15) { flash("O período mínimo de inatividade é 15 dias.", "error"); return; }
    const s = JSON.parse(JSON.stringify(state));
    const p = s.players.find(x => x.id === parseInt(inactivePlayer));
    if (!p) return;

    // Bug 1: impede sobrescrita se jogador já está inativo
    if (p.inactiveUntil && new Date(p.inactiveUntil) > new Date()) {
      flash(`${p.name} já está inativo até ${new Date(p.inactiveUntil).toLocaleDateString("pt-BR")}. Encerre o período atual antes de registrar um novo.`, "error");
      return;
    }

    p.inactiveSince = todayStrBR();
    p.inactiveUntil = inactiveDaysUntilBR(days);

    const notif = { playerId: p.id, text: `Você foi marcado como inativo por ${days} dias (até ${new Date(p.inactiveUntil).toLocaleDateString("pt-BR")}).`, date: nowBR(), read: false };
    await dbInsertNotifications([notif], gender);
    s.notifications.unshift({ ...notif, id: Date.now() });
    save(s);
    try { await dbSavePlayers([p], gender); } catch (e) { flash("Erro ao registrar inatividade.", "error"); return; }
    flash(`Inatividade de ${days} dias registrada para ${p.name}.`);
  }

  /**
   * Encerra inatividade de um jogador.
   * @param {number|null} playerId — se fornecido, usa esse id; caso contrário usa o estado inactivePlayer
   */
  async function removeInactivity(playerId) {
    const targetId = playerId != null ? playerId : parseInt(inactivePlayer);
    if (!targetId) return;
    const s = JSON.parse(JSON.stringify(state));
    const p = s.players.find(x => x.id === targetId);
    if (!p) return;

    // Salvar since/until antes de zerar (serão usados para gravar histórico)
    const sinceDate = p.inactiveSince;
    const now = nowBR();
    const untilDate = (p.inactiveUntil || now).slice(0, 10);
    const histPrev = inactivityHistory.filter(h => h.playerId === p.id);
    const histDays = histPrev.reduce((acc, h) => acc + h.days, 0);
    const currentDays = sinceDate
      ? Math.max(1, Math.round((new Date(untilDate) - new Date(sinceDate + "T12:00:00")) / 86400000))
      : 0;
    const newYtd = histDays + currentDays;

    const prevYtd = histDays; // ytd antes deste período = só o histórico
    const { penalty, faixa, label } = getInactivityPenalty(newYtd);
    const prevPenalty = getInactivityPenalty(prevYtd).penalty;
    const penaltyDiff = penalty - prevPenalty;

    const notifLines = [`Inatividade encerrada. Total acumulado no ano: ${newYtd} dias (Faixa ${faixa}: ${label}).`];

    if (penaltyDiff > 0) {
      const prevPositions = {};
      s.players.forEach(x => { prevPositions[x.id] = x.position; });
      const oldPos = p.position;
      const newPos = Math.min(oldPos + penaltyDiff, s.players.length);
      s.players.forEach(x => { if (x.id !== p.id && x.position > oldPos && x.position <= newPos) x.position--; });
      p.position = newPos;
      p.positionDelta = -(penaltyDiff);
      p.positionDeltaDate = now;
      const reasonMap = { [p.id]: { reason: "inactivity", detail: `Penalidade de inatividade (Faixa ${faixa}) — caiu ${penaltyDiff} posições (#${oldPos} → #${newPos})` } };
      const histEntries = buildPositionHistoryEntries(s.players, prevPositions, now, reasonMap);
      notifLines.push(`Penalidade aplicada: −${penaltyDiff} posições (#${oldPos} → #${newPos}).`);
      p.inactiveUntil = null;
      p.inactiveSince = null;
      save(s);
      try {
        await dbSavePlayers(s.players, gender);
        await dbInsertPositionHistory(histEntries, gender);
      } catch (e) { flash("Erro ao aplicar penalidade.", "error"); return; }
    } else {
      p.inactiveUntil = null;
      p.inactiveSince = null;
      save(s);
      try { await dbSavePlayers([p], gender); } catch (e) { flash("Erro ao remover inatividade.", "error"); return; }
    }

    // Grava no histórico de inatividade
    if (sinceDate) {
      const { faixa: faixaHist } = getInactivityPenalty(newYtd);
      try {
        await dbInsertInactivityHistory({
          playerId: p.id,
          playerName: p.name,
          since: sinceDate,
          until: untilDate,
          days: currentDays,
          ytdTotal: newYtd,
          penalty: penaltyDiff,
          faixa: faixaHist,
        }, gender);
        const updated = await dbLoadAllInactivityHistory(gender);
        setInactivityHistory(updated);
      } catch (e) { console.warn("Erro ao gravar histórico de inatividade:", e); }
    }

    const notif = { playerId: p.id, text: notifLines.join(" "), date: now, read: false };
    await dbInsertNotifications([notif], gender);
    s.notifications.unshift({ ...notif, id: Date.now() });
    save({ ...s });
    flash(`Inatividade encerrada para ${p.name}.${penaltyDiff > 0 ? ` Penalidade: −${penaltyDiff} posições.` : " Sem penalidade."}`);
  }

  // type: "challenger" | "challenged" | "all"
  async function unblockPlayer(pid, type = "all") {
    const s = JSON.parse(JSON.stringify(state));
    const p = s.players.find(x => x.id === pid);
    if (!p) return;
    if (type === "challenger" || type === "all") p.blockedAsChallenger = null;
    if (type === "challenged" || type === "all") p.blockedAsChallenged = null;
    const textMap = {
      challenger: "Seu bloqueio para desafiar foi removido pelo admin.",
      challenged: "Seu bloqueio para receber desafios foi removido pelo admin.",
      all: "Seus bloqueios foram removidos pelo admin.",
    };
    const flashMap = {
      challenger: p.name + " pode voltar a desafiar.",
      challenged: p.name + " pode voltar a receber desafios.",
      all: p.name + " desbloqueado.",
    };
    const notif = { playerId: p.id, text: textMap[type], date: nowBR(), read: false };
    try { await dbSavePlayers([p], gender); await dbInsertNotifications([notif], gender); } catch (e) { flash("Erro ao desbloquear.", "error"); return; }
    s.notifications.unshift({ ...notif, id: Date.now() });
    save(s); flash(flashMap[type]);
  }

  async function addHistoricalInactivity() {
    if (!histPlayerId) { flash("Selecione o jogador.", "error"); return; }
    if (!histSince || !histUntil) { flash("Informe início e fim do período.", "error"); return; }
    if (histSince >= histUntil) { flash("A data de início deve ser anterior ao fim.", "error"); return; }
    const days = Math.max(1, Math.round((new Date(histUntil) - new Date(histSince)) / 86400000));
    const p = state.players.find(x => x.id === parseInt(histPlayerId));
    if (!p) return;
    const penalty = parseInt(histPenalty) || 0;
    const faixaMap = { 0: "I", 5: "II", 10: "III", 15: "IV", 20: "V", 25: "VI" };
    const faixaStr = faixaMap[penalty] || "I";
    try {
      await dbInsertInactivityHistory({
        playerId: p.id,
        playerName: p.name,
        since: histSince,
        until: histUntil,
        days,
        ytdTotal: days,
        penalty,
        faixa: faixaStr,
      }, gender);
      const updated = await dbLoadAllInactivityHistory(gender);
      setInactivityHistory(updated);
      setHistPlayerId(""); setHistPlayerSearch(""); setHistSince(""); setHistUntil(""); setHistPenalty(0);
      flash(`Período histórico de ${p.name} registrado.`);
    } catch (e) { console.error(e); flash("Erro ao registrar histórico.", "error"); }
  }

  async function updateHistoricalInactivity() {
    if (!editingHistId) return;
    if (!editHistSince || !editHistUntil) { flash("Informe início e fim.", "error"); return; }
    if (editHistSince >= editHistUntil) { flash("Data de início deve ser anterior ao fim.", "error"); return; }
    const days = Math.max(1, Math.round((new Date(editHistUntil) - new Date(editHistSince)) / 86400000));
    const penalty = parseInt(editHistPenalty) || 0;
    const faixaMap = { 0: "I", 5: "II", 10: "III", 15: "IV", 20: "V", 25: "VI" };
    const faixaStr = faixaMap[penalty] || "I";
    try {
      await dbUpdateInactivityHistory(editingHistId, {
        since: editHistSince,
        until: editHistUntil,
        days,
        ytdTotal: days,
        penalty,
        faixa: faixaStr,
      }, gender);
      const updated = await dbLoadAllInactivityHistory(gender);
      setInactivityHistory(updated);
      setEditingHistId(null);
      flash("Período atualizado.");
    } catch (e) { console.error(e); flash("Erro ao atualizar período.", "error"); }
  }

  async function deleteHistoricalInactivity(id) {
    try {
      await dbDeleteInactivityHistory(id, gender);
      setInactivityHistory(prev => prev.filter(h => h.id !== id));
      flash("Período removido.");
    } catch (e) { console.error(e); flash("Erro ao remover período.", "error"); }
  }

  async function loadInactivityHistory() {
    setHistLoading(true);
    try {
      const data = await dbLoadAllInactivityHistory(gender);
      setInactivityHistory(data);
    } catch (e) { console.warn(e); }
    setHistLoading(false);
  }

  // ── Regras (compartilhadas — sem gender) ────────────────────────────────────
  async function saveRule() {
    if (!editingRule) return;
    const updated = { id: editingRule.id, icon: editRuleIcon, title: editRuleTitle, text: editRuleText };
    try {
      const { error } = await supabase.from("rules").upsert(updated, { onConflict: "id" });
      if (error) throw error;
    } catch (e) { flash("Erro ao salvar regra.", "error"); return; }
    const s = JSON.parse(JSON.stringify(state));
    const activeRules = s.rules || RULES_SECTIONS.map((r, i) => ({ ...r, id: i + 1 }));
    const idx = activeRules.findIndex(r => r.id === editingRule.id);
    if (idx >= 0) activeRules[idx] = updated; else activeRules.push(updated);
    s.rules = activeRules;
    save(s); setEditingRule(null); flash("Regra atualizada!");
  }

  // ── Datas bloqueadas (compartilhadas — sem gender) ──────────────────────────
  async function addBlockedDate() {
    if (!blockDate) { flash("Selecione uma data.", "error"); return; }
    if (!blockAllDay && blockHours.length === 0) { flash("Selecione ao menos um horário.", "error"); return; }
    const existing = state.blockedDates;
    if (existing.find(b => b.date === blockDate && b.allDay)) { flash("Essa data já está bloqueada inteiramente.", "error"); return; }
    const entry = { date: blockDate, allDay: blockAllDay, blockedHours: blockAllDay ? [] : blockHours };
    try {
      const newId = await dbInsertBlockedDate(entry);
      const s = JSON.parse(JSON.stringify(state));
      s.blockedDates = [...s.blockedDates, { ...entry, id: newId }];
      save(s); setBlockDate(""); setBlockAllDay(true); setBlockHours([]);
      flash("Data bloqueada com sucesso.");
    } catch (e) { console.error(e); flash("Erro ao bloquear data.", "error"); }
  }

  async function removeBlockedDate(id) {
    try {
      await dbDeleteBlockedDate(id);
      const s = JSON.parse(JSON.stringify(state));
      s.blockedDates = s.blockedDates.filter(b => b.id !== id);
      save(s); flash("Bloqueio removido.");
    } catch (e) { console.error(e); flash("Erro ao remover bloqueio.", "error"); }
  }

  // ── Court Slots ─────────────────────────────────────────────────────────────
  async function addCourtSlot() {
    if (!slotHour) { flash("Informe o horário.", "error"); return; }
    const existing = (state.courtSlots || []);
    if (existing.find(s => s.dayType === slotDayType && s.hour === slotHour)) {
      flash("Esse horário já existe para este tipo de dia.", "error"); return;
    }
    try {
      const newId = await dbUpsertCourtSlot({ dayType: slotDayType, hour: slotHour, maxCourts: slotMaxCourts });
      const s = JSON.parse(JSON.stringify(state));
      s.courtSlots = [...existing, { id: newId, dayType: slotDayType, hour: slotHour, maxCourts: slotMaxCourts }];
      save(s); setSlotHour(""); setSlotMaxCourts(1);
      flash("Horário adicionado.");
    } catch (e) { console.error(e); flash("Erro ao adicionar horário.", "error"); }
  }

  async function updateCourtSlot(id, maxCourts) {
    try {
      const slot = (state.courtSlots || []).find(s => s.id === id);
      if (!slot) return;
      await dbUpsertCourtSlot({ id, hour: slot.hour, maxCourts });
      const s = JSON.parse(JSON.stringify(state));
      s.courtSlots = s.courtSlots.map(sl => sl.id === id ? { ...sl, maxCourts } : sl);
      save(s); flash("Quadras atualizadas.");
    } catch (e) { console.error(e); flash("Erro ao atualizar.", "error"); }
  }

  async function removeCourtSlot(id) {
    try {
      await dbDeleteCourtSlot(id);
      const s = JSON.parse(JSON.stringify(state));
      s.courtSlots = (s.courtSlots || []).filter(sl => sl.id !== id);
      save(s); flash("Horário removido.");
    } catch (e) { console.error(e); flash("Erro ao remover horário.", "error"); }
  }

  // ── Blocked Periods ──────────────────────────────────────────────────────────
  async function addBlockedPeriod() {
    if (!periodDateFrom || !periodDateTo) { flash("Informe início e fim do período.", "error"); return; }
    if (periodDateFrom > periodDateTo) { flash("Data de início deve ser anterior ao fim.", "error"); return; }
    if (!periodAllDay && periodHours.length === 0) { flash("Selecione ao menos um horário.", "error"); return; }
    try {
      const newId = await dbInsertBlockedPeriod({
        dateFrom: periodDateFrom, dateTo: periodDateTo,
        allDay: periodAllDay, blockedHours: periodAllDay ? [] : periodHours,
        label: periodLabel,
      });
      const s = JSON.parse(JSON.stringify(state));
      s.blockedPeriods = [...(s.blockedPeriods || []), {
        id: newId, dateFrom: periodDateFrom, dateTo: periodDateTo,
        allDay: periodAllDay, blockedHours: periodAllDay ? [] : periodHours,
        label: periodLabel,
      }];
      save(s);
      setPeriodDateFrom(""); setPeriodDateTo(""); setPeriodAllDay(true);
      setPeriodHours([]); setPeriodLabel("");
      flash("Período bloqueado com sucesso.");
    } catch (e) { console.error(e); flash("Erro ao bloquear período.", "error"); }
  }

  async function removeBlockedPeriod(id) {
    try {
      await dbDeleteBlockedPeriod(id);
      const s = JSON.parse(JSON.stringify(state));
      s.blockedPeriods = (s.blockedPeriods || []).filter(p => p.id !== id);
      save(s); flash("Período desbloqueado.");
    } catch (e) { console.error(e); flash("Erro ao remover período.", "error"); }
  }

  // ── Feriados (compartilhados — sem gender) ──────────────────────────────────
  async function addHoliday() {
    if (!holidayDate) { flash("Selecione uma data.", "error"); return; }
    if (!holidayName.trim()) { flash("Informe o nome do feriado.", "error"); return; }
    const existing = (state.holidays || []);
    if (existing.find(h => h.date === holidayDate)) { flash("Essa data já está cadastrada como feriado.", "error"); return; }
    try {
      const newHoliday = await dbAddHoliday({ date: holidayDate, name: holidayName.trim() });
      const s = JSON.parse(JSON.stringify(state));
      s.holidays = [...existing, newHoliday];
      save(s); setHolidayDate(""); setHolidayName(""); flash("Feriado cadastrado com sucesso.");
    } catch (e) { console.error(e); flash("Erro ao cadastrar feriado.", "error"); }
  }

  async function removeHoliday(id) {
    try {
      await dbDeleteHoliday(id);
      const s = JSON.parse(JSON.stringify(state));
      s.holidays = (s.holidays || []).filter(h => h.id !== id);
      save(s); flash("Feriado removido.");
    } catch (e) { console.error(e); flash("Erro ao remover feriado.", "error"); }
  }

  return {
    adminTab, setAdminTab,
    newPlayerName, setNewPlayerName,
    removePlayerId, setRemovePlayerId, removeConfirm, setRemoveConfirm,
    resetPlayerId, setResetPlayerId, resetNewPass, setResetNewPass,
    adjustPlayerId, setAdjustPlayerId, adjustPosition, setAdjustPosition,
    editPlayerModal, setEditPlayerModal,
    editPlayerName, setEditPlayerName,
    editPlayerEmail, setEditPlayerEmail,
    editPlayerPhone, setEditPlayerPhone,
    adminChrID, setAdminChrID, adminChdID, setAdminChdID, adminChalDate, setAdminChalDate,
    cancelChalId, setCancelChalId, cancelChalConfirm, setCancelChalConfirm,
    editChalId, setEditChalId, editChalDate, setEditChalDate,
    propAsChrID, setPropAsChrID, propAsChdID, setPropAsChdID,
    propAsDates, setPropAsDates,
    resultChalId, setResultChalId, resultWinner, setResultWinner,
    resultType, setResultType, resultSets, setResultSets,
    resultConfirmModal, setResultConfirmModal,
    editResultId, setEditResultId, editResultWinner, setEditResultWinner,
    editResultType, setEditResultType, editResultSets, setEditResultSets,
    inactivePlayer, setInactivePlayer, inactiveSearch, setInactiveSearch,
    inactiveSearchOpen, setInactiveSearchOpen, inactiveDays, setInactiveDays,
    inactivityHistory, loadInactivityHistory, histLoading,
    histPlayerSearch, setHistPlayerSearch, histPlayerSearchOpen, setHistPlayerSearchOpen,
    histPlayerId, setHistPlayerId,
    histSince, setHistSince, histUntil, setHistUntil, histPenalty, setHistPenalty,
    addHistoricalInactivity,
    editingHistId, setEditingHistId,
    editHistSince, setEditHistSince, editHistUntil, setEditHistUntil,
    editHistPenalty, setEditHistPenalty,
    updateHistoricalInactivity, deleteHistoricalInactivity,
    editingRule, setEditingRule, editRuleIcon, setEditRuleIcon,
    editRuleTitle, setEditRuleTitle, editRuleText, setEditRuleText,
    blockDate, setBlockDate, blockAllDay, setBlockAllDay, blockHours, setBlockHours,
    holidayDate, setHolidayDate, holidayName, setHolidayName,
    addPlayer, removePlayer, resetPassword, adjustPlayerPosition, saveEditPlayer,
    cancelChallenge, adminProposeChallenge, adminProposeAsPlayer, editChallengeDate,
    requestResultConfirm, registerResult, saveEditResult, deleteResult,
    setInactivity, removeInactivity, unblockPlayer,
    saveRule, addBlockedDate, removeBlockedDate,
    addHoliday, removeHoliday,
    slotDayType, setSlotDayType, slotHour, setSlotHour, slotMaxCourts, setSlotMaxCourts,
    addCourtSlot, updateCourtSlot, removeCourtSlot,
    periodDateFrom, setPeriodDateFrom, periodDateTo, setPeriodDateTo,
    periodAllDay, setPeriodAllDay, periodHours, setPeriodHours,
    periodLabel, setPeriodLabel,
    addBlockedPeriod, removeBlockedPeriod,
  };
}
